import { render } from "./ward_setting.vue?vue&type=template&id=3b5ee8f5&scoped=true"
import script from "./ward_setting.vue?vue&type=script&lang=js"
export * from "./ward_setting.vue?vue&type=script&lang=js"

import "./ward_setting.vue?vue&type=style&index=0&id=3b5ee8f5&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5ee8f5"]])

export default __exports__